import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/**
 * TS Lot 1 §7.1 Collection block — the overdue-invoice list.
 *
 * Not period-scoped: an invoice is overdue as of *now*, so the dashboard's
 * period selector does not apply to it (the aging summary beside it is the
 * period-scoped view). Client review AL-2026/08-04-01, finding D-04.
 */
export function useMDOverdueInvoices(limit = 20) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdOverdueInvoices(),
    queryFn: () => dashboardApi.getMDOverdueInvoices(limit),
  });
}
